// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","root":"Badge_root__dYUgl","text":"Badge_text__1ar5Q","primary":"Badge_primary__25Xhk"};